import 'babel-polyfill'
import 'whatwg-fetch'
export * from './custom_views/app'

import 'picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import 'lazysizes';